module.exports = __webpack_public_path__ + "img/0Q3A9771_L_Wood.37c4d391.jpg";